import Classes from "./_classes";
import Interfaces from "./_interfaces";
import NotificationUtil from "./_notificationUtil";
import Modal from "./_bootstrapModalExtensions";
import * as Url from "./Utils/UrlUtil";

interface ITakarnetSettlementModel {
    id: number;
    displayName: string;
}

export const ValidEstateMessage: string = 'Az ellenőrzés pillanatában létező helyrajzi szám a Takarnetben.';
export const NotFoundEstateMessage: string = 'A megadott helyrajzi szám nem található meg a Takarnetben. Kérjük, ellenőrizze az ingatlan fekvését, a helyrajzi számot és a Takarnet települést!';
export const MultipleEstateFoundMessage: string = 'A megadott helyrajzi szám nem pontos, több találatot ad rá a Takarnet keresés.';

export function ValidateRealtyFromGrid(event: JQuery.TriggeredEvent) {
    let $takarnetBtn: JQuery = $(event.currentTarget);
    let $takarnetBtnIcon: JQuery = $takarnetBtn.find("span");
    let $editBtn: JQuery = $takarnetBtn.closest(".action-row-actions").find(".edit-subject-estate");
    let $takarnetBtnIconOrig: JQuery = $takarnetBtnIcon.clone();
    let isTakarnetSettlementSet: boolean = $takarnetBtn.data('is-takarnetsettlement-set') == 'True';
    let estateId: number = $takarnetBtn.data('estateid');

    if (!isTakarnetSettlementSet) {
        NotificationUtil.Warning('A Takarnet település mező nincsen kitöltve!');
        return;
    }

    $takarnetBtn
        .prop('disabled', true);

    $takarnetBtnIcon
        .removeClass()
        .addClass('spinner-border')

    const cbOnFailure: () => void = () => { $takarnetBtnIcon.replaceWith($takarnetBtnIconOrig); };
    let grid: Interfaces.MVCxClientGridViewWithScrollToRowIndex = window['ProcessEstates'] as Interfaces.MVCxClientGridViewWithScrollToRowIndex;

    GetCountOfMatchedRealtiesFromTakarnet(estateId, cbOnFailure)
        .then(model => {
            if (model.success) {
                // Everything went fine, decide which icon should be displayed
                let numberOfRealties: number = model.result as number;

                if (numberOfRealties === 1) {
                    $takarnetBtnIcon
                        .removeClass()
                        .addClass('icon-ico-check-square font-size-1-25 text-success');

                    $takarnetBtn
                        .attr('title', ValidEstateMessage);

                    $editBtn
                        .prop('disabled', true)
                        .attr('title', "Az ingatlant ellenőrizve van a TakarNet által, így annak adatai a továbbiakban nem módosíthatóak! Ha az ingatlan adatainak módosítása szükséges, kérjük vegyen fel egy új ingatlant ezt pedig törölje!");

                    setTitleDeedBtn();
                } else if (numberOfRealties === 0) {
                    $takarnetBtnIcon
                        .removeClass()
                        .addClass('icon-ico-window-close font-size-1-25 text-danger');

                    $takarnetBtn
                        .attr('title', NotFoundEstateMessage);
                } else {
                    $takarnetBtnIcon
                        .removeClass()
                        .addClass('icon-ico-warning-2 text-warning position-relative top1px');

                    $takarnetBtn
                        .attr('title', MultipleEstateFoundMessage);
                }

                scrollToRowIndex();
                refreshGrid();
            }
            else {
                NotificationUtil.Error(model.message);

                scrollToRowIndex();
                refreshGrid();
            }
        });

    function scrollToRowIndex() {
        grid.scrollToRowIndex = grid.GetRowIndicesVisibleInViewPort(false)[0];
    }

    function refreshGrid() {
        grid.Refresh();
    }

    function setTitleDeedBtn() {
        const $btn: JQuery<HTMLButtonElement> = $('#title-deed-dload-btn-' + estateId);

        removeFurtherOptionsButtonFromGroup();

        setButtonGroupToVisible();

        function removeFurtherOptionsButtonFromGroup(){
            $btn.siblings().remove();
        }

        function setButtonGroupToVisible() {
            $btn.parent().removeClass('d-none');
        }
    }
}

export function GetCountOfMatchedRealtiesFromTakarnet(estateId: number, callbackOnFailure: Function): Promise<Interfaces.JsonResponseWithResult> {
    return new Promise<Interfaces.JsonResponseWithResult>((resolve, reject) => {
        $.ajax({
            method: 'GET',
            url: window.ETDR_RD.appConfig["UrlAction.GetNumberOfRealtiesByTopoNumber"],
            data: {
                'estateId': estateId
            },
            headers: { Accept: 'application/json' }
        })
            .done((data) => {
                let model: Interfaces.JsonResponseWithResult = data as Interfaces.JsonResponseWithResult;

                resolve(model);
            })
            .fail((jqXHR: JQueryXHR) => {

                NotifyUserAboutAjaxCallFailure(jqXHR);

                callbackOnFailure();
            });
    });
}

export function FillupTakarnetSettlementList() {
    let $dropdown: JQuery<HTMLElement> = $('#TakarnetSettlementId');
    let $settlementIdInput: JQuery<HTMLElement> = $('input.settlement-id');
    let settlementId: number = $settlementIdInput.val() as number;

    if ($dropdown.length === 0 || !$settlementIdInput || settlementId < 1) {
        return;
    }

    $.ajax({
        method: 'GET',
        url: window.ETDR_RD.appConfig["UrlAction.GetTakarnetSettlementsBySettlementId"],
        data: {
            'settlementId': settlementId
        },
        headers: { Accept: 'application/json' }
    })
        .done((data) => {
            if (data.success) {
                // Empty the drop down list
                $dropdown.empty();

                // Parse the json object
                let takarnetSettlementList: ITakarnetSettlementModel[] = JSON.parse(data.result) as ITakarnetSettlementModel[];

                // If the list contains one element, then make sure that is the only one, so it is being selected by default
                if (takarnetSettlementList.length > 1) {
                    $dropdown.append($("<option />").val('').text('- Kérem válasszon -'));
                }

                // Populate the dropdown
                $.each(takarnetSettlementList, function () {
                    $dropdown.append($("<option />").val(this.id).text(this.displayName));
                });
            } else {
                NotificationUtil.Error("A Takarnet településlista lekérdezése sikertelen.");
            }
        })
        .fail((jqXHR: JQueryXHR) => {
            NotifyUserAboutAjaxCallFailure(jqXHR);
        });
}

export function NotifyUserAboutAjaxCallFailure(jqXHR: JQueryXHR) {
    // If the frontend server threw an exception (e.g. 404, internal server error, etc)
    let errorText: string;
    let responseErrorMessage: string = jqXHR.responseJSON.message;

    if (responseErrorMessage) {
        errorText = responseErrorMessage;
    } else {
        errorText = 'Hiba történt a lekérés során. Kérjük, töltse újra az oldalt vagy próbálja meg később!';
    }

    NotificationUtil.Error(errorText);
}

export function OpenTitleDeedHistoryModalWindow(event: JQuery.TriggeredEvent) {
    let titleDeedButton: HTMLElement = $(event.currentTarget).parent().children()[0];
    const estateId: number = $(titleDeedButton).data('estate-id');
    const url: string = Url.createUrlFromTemplate(window.ETDR_RD.appConfig['UrlTemplate.MultipleTitleDeedModalWindow'], { estateId: estateId });
    const settings: Classes.BootstrapModalWithAjaxContentSettings = GetModalSettings();

    Modal.showBootstrapModalWithAjaxContent(settings);

    function GetModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'Ingatlan-nyilvántartásból lekérdezett tulajdoni lapok időállapot szerint';
        settings.contentUrl = url;
        settings.showRejectButton = false;
        settings.showSaveButton = false;

        return settings;
    }
}

jQuery(() => {
    $(document).on('change', '.settlement-id', () => {
        FillupTakarnetSettlementList();
    });

    $(document).on('click', '.takarnet-realty-check', (event: JQuery.TriggeredEvent) => {
        ValidateRealtyFromGrid(event);
    });

    $(document).on('click', '#title-deed-history-modal-btn', (event: JQuery.TriggeredEvent) => {
        OpenTitleDeedHistoryModalWindow(event);
    });
});
